import { jsx as _jsx } from "react/jsx-runtime";
export default function Logo() {
    return (_jsx("div", { className: "flex justify-center border-b border-b-gray-300", children: _jsx("img", { src: "https://assets.explore-share.com/statics/logos/es-black", height: "auto", width: "120", alt: "Explore-Share logo and link to home", decoding: "async", loading: "lazy", className: 'my-2' }) }));
}
